import {isNil, omitBy, map, filter, isNull} from 'lodash';
import moment from "moment";

//Normaliser for customer setting listing
const response = (data: any, inactiveSettings?) => {
    const convertData = (input) => {

      //To indicate whether or not the setting status can be updated
      const isUpdatable = !isNull(input._id.match(/customer/gi))
      const normalizedData = omitBy({
        isFixedAmount: !!input?.data.surcharge?.fixedAmount,
        isPercentage: !!input?.data.surcharge?.percentage,
        surcharge:{
          fixedAmount: isUpdatable===true? input?.surcharge?.fixedAmount : input?.data.surcharge?.fixedAmount || null,
          percentage: isUpdatable===true? input?.surcharge?.percentage : input?.data.surcharge?.percentage || null,
        },
        capAmount: input?.data.surcharge?.capAmount || null,
        validFrom: input?.data.validFrom ? moment(input.validFrom) : null,
        validTo:  input?.data.validTo ? moment(input.validTo) : null,
        length: input?.data.maxDimension?.length,
        width:  input?.data.maxDimension?.width,
        height:  input?.data.maxDimension?.height,
        orderSettingID: input?.orderSettingID,
        isUpdatable: isUpdatable,
      },isNil)

      return normalizedData;
    }


    const activeVersion = {
        ...data,
        ...data.data,
        ...convertData(data),
    }

    data.versions = filter(inactiveSettings, inactiveSettingObj=>{
      return inactiveSettingObj.code == data.code
    })

    let versionList = map(data.versions,versionObj=>{
      return {...versionObj,...convertData(versionObj)}
    })

    versionList.unshift(activeVersion)

    return omitBy({
        ...activeVersion,
        versions: versionList
    }, isNil)
}

export default response;
